<template>
  <div class="flex items-center gap-2">
    <label v-if="!hideLabel">
      Filter
    </label>
    <Listbox
      v-model="filter"
      @update:model-value="store.setFilterUrl(filter)"
    >
      <div class="z-20 w-full relative">
        <ListboxButton class="hui-dropdown-button w-full">
          <div class="flex items-center gap-4">
            <svg-icon
              :name="`filter-${filter}`"
              class="w-5 h-5"
            />
            <span class="block truncate">
              {{ $t(`bundler.filters.${filter}`) }}
            </span>
          </div>
          <span class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-4">
            <svg-icon
              name="chevron-down"
              class="w-3 h-3 text-gray-400"
            />
          </span>
        </ListboxButton>
        <transition
          leave-active-class="transition duration-100 ease-in"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <ListboxOptions class="hui-dropdown-list right-0">
            <ListboxOption
              v-for="(label, option) in availableFilters"
              v-slot="{ active }"
              :key="option"
              :value="option"
              as="template"
            >
              <li :class="active && 'active'">
                <svg-icon
                  :name="`filter-${option}`"
                  class="w-5 h-5"
                />
                <span class="whitespace-nowrap">
                  {{ $t(`bundler.filters.${option}`) }}
                </span>
              </li>
            </ListboxOption>
          </ListboxOptions>
        </transition>
      </div>
    </Listbox>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import {
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption
} from '@headlessui/vue'
import { useProductsStore } from '@/stores'
interface Props {
  hideLabel?: boolean
}
defineProps<Props>()
const store = useProductsStore()
const { filter, availableFilters } = storeToRefs(store)
</script>
